export default __webpack_public_path__ + "static/media/actionf.329f470b.png";